import { render } from "./ks-contacts.vue?vue&type=template&id=2d2685b4"
import script from "./ks-contacts.vue?vue&type=script&lang=js"
export * from "./ks-contacts.vue?vue&type=script&lang=js"

import "./ks-contacts.vue?vue&type=style&index=0&id=2d2685b4&lang=css"
script.render = render

export default script